import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import ReactQuill from "react-quill";
import { MdArrowBack, MdFilePresent, MdCalendarMonth, MdClose, MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { Dialog, DialogActions, DialogContent, Button, DialogContentText, DialogTitle } from "@mui/material";
import { web_url } from "../../constant";
import { useWebSocket } from "../../websocket_context";
import { attachParent } from "rsuite/esm/internals/utils";

function TranslatorMailDashboardDesktop() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
    }, [language]);

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });
    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false)
    const [isLoading2, setIsLoading2] = useState(false)

    const [moderatedAttachments, setModeratedAttachments] = useState([]);

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('already seen')) {
            setError(t('t409'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t214'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        localStorage.setItem("refresh", `${Date.now()}`);
        setOpenError(false);
    };

    const [searchInput, setSearchInput] = useState("");
    const navigate = useNavigate();

    const [mailsInbox, setMailsInbox] = useState([]);

    const [mailsRejected, setMailsRejected] = useState([]);

    const [date, setDate] = useState(null)

    const [showCloseIcon, setShowCloseIcon] = useState(null)
    const getLogDetails = () => {
        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    };
    const logDetails = getLogDetails();
    const messageIdsSet = useRef(new Set());
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (!logDetails) return;

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        const loadMessages = (studentList) => {
            setIsLoading(true);
            axios.post(`${web_url}/api/email-threads/participants/translators-moderate`, studentList, configToken).then((response) => {
                let allMessages = response.data.flatMap(
                    message => ({
                        ...message,
                        sentAt: formatDate(message.sentAt),
                        sentAtOriginal: formatDateNew(message.sentAt),
                        other: (message.participants.filter(email => email !== message.sender))[0]
                    }));

                allMessages.sort((a, b) => new Date(b.sentAt.replace(/-/g, "/")) - new Date(a.sentAt.replace(/-/g, "/")));
                const receivedMessages = allMessages.filter(msg => studentList.includes(msg.sender) && msg.status === "PENDING" && (!msg.allocatedTranslator || msg.allocatedTranslator === logDetails.email));
                const rejectedMessages = allMessages.filter(msg => studentList.includes(msg.sender) && msg.status === "REJECTED" && msg.moderationRecord.moderator === logDetails.email);

                setMailsInbox(receivedMessages);
                setMailsRejected(rejectedMessages);
                receivedMessages.forEach(msg => messageIdsSet.current.add(msg.messageId));
                rejectedMessages.forEach(msg => messageIdsSet.current.add(msg.messageId));

                setIsLoading(false);
                setIsDataLoaded(true);
            }).catch((err) => {
                setIsLoading(false);
                handleClickOpenError("error occured");
            });
        };

        const cachedStudents = JSON.parse(localStorage.getItem('students-assigned') || "[]");
        if (cachedStudents.length > 0) {
            loadMessages(cachedStudents);
        } else {
            setIsLoading(true);
            axios.get(`${web_url}/api/auth/translators/${logDetails.email}`, configToken).then((response) => {
                const schoolIds = response.data.schoolIds || [];
                if (schoolIds.length > 0) {
                    axios.get(`${web_url}/api/auth/schools`, configToken).then((resSchoolList) => {
                        const assignedSchoolNames = new Set(
                            resSchoolList.data
                                .filter(school => schoolIds.includes(school.id))
                                .map(school => (school.name || "").trim().toLowerCase())
                        );

                        axios.get(`${web_url}/api/auth/students`, configToken).then((resStudents) => {
                            const studentEmails = resStudents.data
                                .filter(student => student.school && assignedSchoolNames.has(student.school.trim().toLowerCase()))
                                .map(student => student.userEmail);

                            localStorage.setItem('students-assigned', JSON.stringify(studentEmails));
                            loadMessages(studentEmails);
                        }).catch(() => {
                            setIsLoading(false);
                        });
                    }).catch(() => {
                        setIsLoading(false);
                    });
                } else {
                    setIsLoading(false);
                }
            }).catch(() => {
                setIsLoading(false);
            });
        }
    }, [localStorage.getItem('refresh')])


    const { subscribeToTopic } = useWebSocket();


    useEffect(() => {
        if (!isDataLoaded) return;
        subscribeToTopic((data) => {
            const responseBody = data;
            let messages = responseBody.messages.map(message => ({
                ...message,
                threadId: responseBody.threadId,
                subject: (responseBody.subject) || " ",
                translatedSubject: (responseBody.translatedSubject) || " ",
                sentAt: formatDate(message.sentAt),
                sentAtOriginal: formatDateNew(message.sentAt),
                other: (responseBody.participants.filter(email => email !== message.sender))[0]
            }));

            messages.sort((a, b) => new Date(b.sentAt.replace(/-/g, "/")) - new Date(a.sentAt.replace(/-/g, "/")));
            const studentList = JSON.parse(localStorage.getItem('students-assigned'));
            const receivedMessages = messages.filter(msg => studentList.includes(msg.sender) && msg.isDraft === "FALSE" && msg.status === "PENDING" && msg.type === "PENPAL" && (!msg.allocatedTranslator || msg.allocatedTranslator === logDetails.email));
            const rejectedMessages = messages.filter(msg => studentList.includes(msg.sender) && msg.isDraft === "FALSE" && msg.type === "PENPAL" && msg.status === "REJECTED" && msg.moderationRecord.moderator === logDetails.email);

            const uniqueReceivedMessages = receivedMessages.filter(msg => {
                if (messageIdsSet.current.has(msg.messageId)) return false;
                messageIdsSet.current.add(msg.messageId);
                return true;
            });

            const uniqueRejectMessages = rejectedMessages.filter(msg => {
                if (messageIdsSet.current.has(msg.messageId)) return false;
                messageIdsSet.current.add(msg.messageId);
                return true;
            });

            setMailsInbox(prev => [...prev, ...uniqueReceivedMessages]);
            setMailsRejected(prev => [...prev, ...uniqueRejectMessages]);
        });

    }, [isDataLoaded]);


    useEffect(() => {
        if (date !== null) {
            setShowCloseIcon(true)
        } else {
            setShowCloseIcon(false)
        }
    }, [date])

    const filteredEmailsInbox = (mailsInbox ?? []).filter((mail) =>
        mail.sender?.toLowerCase().includes(searchInput.toLowerCase()) &&
        (!date || mail.sentAt?.startsWith(date)) // Check if date matches
    );

    const filteredEmailRejected = (mailsRejected ?? []).filter((mail) =>
        mail.other?.toLowerCase().includes(searchInput.toLowerCase()) &&
        (!date || mail.sentAt?.startsWith(date)) // Check if date matches
    );

    const [folderSelected, setFolderSelected] = useState(
        () => {
            const selected = localStorage.getItem('folder') ? parseInt(localStorage.getItem('folder'), 10) : 4;
            // console.log('fold', selected);

            if (selected === 0) {
                return {
                    sent: false,
                    inbox: true,
                    draft: false,
                    rejected: false
                }
            } else if (selected === 1) {
                return {
                    sent: false,
                    inbox: false,
                    draft: false,
                    rejected: true
                }
            } else {
                return {
                    sent: false,
                    inbox: false,
                    draft: false,
                    rejected: false
                }
            }
        }
    )

    const formatDate = (timestamp) => {
        const dateObj = new Date(timestamp);

        // Convert to IST (UTC + 5:30)
        // const istOffset = 0;
        const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
        const istTime = new Date(dateObj.getTime() + istOffset);

        // Use .getFullYear(), .getMonth(), etc., instead of .getUTC*
        const year = istTime.getFullYear();
        const month = String(istTime.getMonth() + 1).padStart(2, "0"); // Ensure 2 digits
        const day = String(istTime.getDate()).padStart(2, "0"); // Ensure 2 digits
        const hours = String(istTime.getHours()).padStart(2, "0"); // Corrected
        const minutes = String(istTime.getMinutes()).padStart(2, "0"); // Corrected
        const sec = String(istTime.getSeconds()).padStart(2, "0"); // Corrected

        // console.log("old", timestamp);
        // console.log("new", `${year}-${month}-${day} ${hours}:${minutes}:${sec}`);

        return `${year}-${month}-${day} ${hours}:${minutes}:${sec}`;
    }

    const formatDateNew = (timestamp) => {
        return new Date(timestamp).toISOString(); // Ensures cross-browser compatibility
    };

    const [content, setContent] = useState({
        messageId: "",
        threadId: "",
        subject: "",
        language: "",
        translatedSubject: "",
        other: '',
        type: '',
        body: "",
        attachments: [],
        moderatedAttachments: []
    });

    const [nowReading, setNowReading] = useState(() => {
        const number = localStorage.getItem('nowreading') ? parseInt(localStorage.getItem('nowreading'), 10) : 100000;
        return number;
    });

    useEffect(() => {
        localStorage.setItem('nowreading', 100000);

    }, [folderSelected])

    const [indexOfMessageShowingNow, setIndexOfMessageShowingNow] = useState(0)

    const [isReceived, setIsReceived] = useState(false);

    // useEffect(() => {
    //     if (localStorage.getItem('mailreceived')) {
    //         const mail = JSON.parse(localStorage.getItem('mailreceived'));
    //         console.log("this is the mail : ",mail);

    //         setTranslatedMessage("")
    //         setContent(mail)
    //         setIsReceived(true)
    //     }

    // }, [localStorage.getItem('mailreceived')])


    useEffect(() => {
        if (localStorage.getItem('mailreceived')) {
            setIsLoading2(true);
            const getLogDetails = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails = getLogDetails();

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };
            const mail = JSON.parse(localStorage.getItem('mailreceived'));
            axios.get(`${web_url}/api/auth/students/${mail.other}`, configToken).then((resStuL) => {

                setTranslatedMessage("");
                setIsReceived(true);
                setContent({
                    ...mail,
                    language: resStuL.data.preferredLanguage,
                    moderatedAttachments: mail.attachments
                });
                setIsLoading2(false);
            }).catch((errorStuL) => {
                setIsLoading2(false);
                handleClickOpenError("error occured");
            })
        }
    }, [localStorage.getItem('mailreceived')])

    const [translatedMessage, setTranslatedMessage] = useState("");
    const [translatedSubject, setTranslatedSubject] = useState("");

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }], // Header options (H1, H2, and normal text)
            ['bold', 'italic', 'underline'], // Inline styles
            [{ list: 'ordered' }, { list: 'bullet' }], // Ordered and unordered lists
        ],
    };

    const [reject, setReject] = useState(false);

    const [rejectMessage, setRejectMessage] = useState("");

    const [rejectError, setRejectError] = useState(false)

    const clickReport = () => {
        if (rejectMessage === "") {
            setRejectError(true);
            return;
        }
        rejectMail();

    }


    const rejectMail = () => {
        setIsLoading(true);
        let message_id = content.messageId;
        let thread_id = content.threadId;
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };
        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${logDetails.token}`,
            },
        };
        const moderationData = {
            moderator: logDetails.email,
            action: "REJECTED",
            approvedAttachments: content.moderatedAttachments,
            reason: rejectMessage
        }
        axios.put(`${web_url}/api/email-threads/${thread_id}/messages/${message_id}/moderate?moderator=${logDetails.email}&action=REJECTED`, moderationData, config).then((response) => {
            let newEmails = mailsInbox.filter((mails) => mails.messageId !== message_id)
            setMailsInbox(newEmails);
            setReject(false);
            setNowReading(100000);
            setIsLoading(false);
            setOpen6(true)
        }).catch((err) => {
            setReject(false);
            setNowReading(100000);
            setIsLoading(false);
            handleClickOpenError("error occured");
        })

    }

    // useEffect(()=>{

    // },[])


    const forwardMail = () => {
        setIsLoading(true);
        let message_id = content.messageId;
        let thread_id = content.threadId;
        let emailUpdates = {};

        if (content.translatedSubject === "startMes") {
            emailUpdates = {
                translatedBody: translatedMessage,
                translatedSubject: translatedSubject
            }
        } else {
            emailUpdates = {
                translatedBody: translatedMessage
            }
        }

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };

        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${logDetails.token}`,
            },
        };

        const moderationData = {
            moderator: logDetails.email,
            action: "APPROVED",
            approvedAttachments: content.moderatedAttachments
        }
        axios.patch(`${web_url}/api/email-threads/${thread_id}/messages/${message_id}`, emailUpdates, config).then((response) => {
            axios.put(`${web_url}/api/email-threads/${thread_id}/messages/${message_id}/moderate?moderator=${logDetails.email}&action=APPROVED`, moderationData, config).then((response) => {
                setIsLoading(false);
                localStorage.removeItem('mailreceived')
                let newEmails = mailsInbox.filter((mails) => mails.messageId !== message_id)
                setContent({
                    messageId: "",
                    threadId: "",
                    subject: "",
                    language: "",
                    translatedSubject: "",
                    other: '',
                    type: '',
                    body: "",
                    moderatedAttachments: [],
                    attachments: []
                })
                setNowReading(100000)
                setMailsInbox(newEmails);
                setOpen7(true)
            }).catch((err2) => {
                console.log('err2 - ', err2);
                setNowReading(100000)
                setIsLoading(false);
                handleClickOpenError("error occured");
            })
        }).catch((err) => {
            setIsLoading(false);
            console.log('err1- ', err);

            handleClickOpenError("error occured");
        })

    }

    const handleChange = (value) => {
        setTranslatedMessage(value);
        // console.log(translatedMessage);

    };

    const handleTranslate = () => {
        setIsLoading(true);
        let languageNow = "";
        if (content.language.toLowerCase() === "english") {
            languageNow = "en"
        } else if (content.language.toLowerCase() === "sinhala") {
            languageNow = "si"
        } else if (content.language.toLowerCase() === "tamil") {
            languageNow = "ta"
        }

        const textAttr = {
            q: content.body,
            target: languageNow,
            format: "html",
        }

        const textAttr2 = {
            q: content.subject.trim(),
            target: languageNow,
            format: "html",
        }

        // console.log('attr', textAttr);

        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=AIzaSyB_TkkxZRCk_V6-k1nfYm-jhfvWNdGG2SA`,
            textAttr, config
        ).then((response) => {

            if (content.subject.trim()) {
                axios.post(
                    `https://translation.googleapis.com/language/translate/v2?key=AIzaSyB_TkkxZRCk_V6-k1nfYm-jhfvWNdGG2SA`,
                    textAttr2, config
                ).then((response2) => {
                    setIsLoading(false);
                    setTranslatedMessage(response.data.data.translations[0].translatedText)
                    setTranslatedSubject(response2.data.data.translations[0].translatedText)
                    setOpen5(true);
                }).catch((err2) => {
                    setIsLoading(false);
                    // console.log('error', err);

                    handleClickOpenError("error occured")
                })
            } else {
                setIsLoading(false);
                setTranslatedMessage(response.data.data.translations[0].translatedText)
                setOpen5(true);
            }

            // setIsLoading(false);
            // setTranslatedMessage(response.data.data.translations[0].translatedText)
            // setOpen5(true);
        }).catch((err) => {
            setIsLoading(false);
            // console.log('error', err);

            handleClickOpenError("error occured")
        })

    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1270) {
                navigate('/mobile/translator/translatemail/inbox')
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [open5, setOpen5] = useState(false)

    const handleClose5 = () => {
        setOpen5(false);
    }

    const [open6, setOpen6] = useState(false)

    const handleClose6 = () => {
        setOpen6(false);
        localStorage.setItem("refresh", `${Date.now()}`);
        setContent((prev) => ({
            ...prev, messageId: "", threadId: "", subject: "", body: "", moderatedAttachments: [], attachments: [], sender: "", language: ""
        }))
        setTranslatedMessage("")
        navigate('/desktop/translator/translatemail')
    }

    const [open7, setOpen7] = useState(false)

    const handleClose7 = () => {
        setOpen7(false);
        localStorage.setItem("refresh", `${Date.now()}`);
        setContent((prev) => ({
            ...prev, messageId: "", threadId: "", subject: "", body: "", moderatedAttachments: [], attachments: [], sender: "", language: ""
        }))
        setTranslatedMessage("")
        navigate('/desktop/translator/translatemail')
    }

    const handleDownload = async (fileName, fileUrl) => {
        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    const handleAllocateTranslator = (mail, index) => {
        console.log('clicked this : ', mail);

        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails.token}`
            },
        };

        if (!mail.allocatedTranslator) {
            axios.patch(`${web_url}/api/email-threads/${mail.threadId}/messages/${mail.messageId}/allocate/${logDetails.email}`, {}, configToken).then((r) => {
                setIsLoading(false);
                if (isXlOrLarger) {
                    setNowReading(index)
                    localStorage.setItem('mailreceived', JSON.stringify(mail));
                    localStorage.removeItem('maildraft');
                    localStorage.removeItem('mailsent');
                    localStorage.setItem('composenewclicked', 'false');
                    navigate('/desktop/translator/translatemail');
                }
            }).catch((e) => {
                setIsLoading(false);
                if (e.response.data.message) {
                    if (e.response.data.message === "Message already has an allocated translator!") {
                        handleClickOpenError('already seen')
                    } else {
                        handleClickOpenError('error occured')
                    }
                } else {
                    handleClickOpenError('error occured')
                }
            })
        } else {
            setIsLoading(false);
            if (isXlOrLarger) {
                setNowReading(index)
                localStorage.setItem('mailreceived', JSON.stringify(mail));
                localStorage.removeItem('maildraft');
                localStorage.removeItem('mailsent');
                localStorage.setItem('composenewclicked', 'false');
                navigate('/desktop/translator/translatemail');
            }
        }

    }

    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "translator") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);


    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-repeat bg-cover min-h-screen w-full xl:pt-[50px]`}>
            <div className="xl:hidden absolute top-0 left-0 py-[25px] pl-[20px] md:pl-[30px] lg:pl-[40px]">
                <div className="flex justify-center items-center" >
                    <img className="h-[50px] md:h-[70px] lg:h-[90px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px]  font-semibold text-[16px] md:text-[20px] lg:text-[25px]">{t('t1')}</p>
                </div>
            </div>
            <Menu as="div" className="xl:hidden absolute top-0 right-0 text-left items-right py-[30px] md:py-[35px] pr-[20px] md:pr-[30px] lg:pr-[40px]">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className="rounded-md hidden xl:grid grid-cols-3 py-[5px] 2xl:py-[10px] bg-gradient-to-r from-[#FFA803] to-[#FFD12E] mx-[70px] px-[20px]">
                <div className="flex justify-start items-center">
                    <img className="h-[40px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] font-semibold text-[20px]">{t('t1')}</p>
                </div>
                <div className="grid grid-cols-3 w-full">
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/home-b.svg" alt="home" onClick={() => navigate('/desktop/translator/dashboard')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t410')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/mail-b.svg" alt="mail" onClick={() => {
                            const mailRequest = {
                                type: 'new',
                                subject: 'nothing'
                            };
                            localStorage.setItem('threadId', JSON.stringify(mailRequest));
                            navigate('/desktop/translator/mailbox')

                        }} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t411')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img title="Settings" src="/images/top-icons/settings-b.svg" alt="settings" onClick={() => navigate('/desktop/translator/settings')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t153')}
                        </span>
                    </div>
                </div>
                <div className="flex justify-end items-center">
                    <Menu as="div" className="text-left items-right">
                        <div>
                            <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                                {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                                <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("English");
                                            changeLanguage('en')
                                        }}
                                    >
                                        English
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Sinhala");
                                            changeLanguage('si')
                                        }}
                                    >
                                        සිංහල
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Tamil");
                                            changeLanguage('ta')
                                        }}
                                    >
                                        தமிழ்
                                    </button>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </Menu>
                </div>
            </div>
            <div className="hidden xl:grid grid-cols-3 w-full">
                <div className="col-span-2">
                    <div className="mb-[100px] lg:mb-[130px] xl:mb-[20px]">
                        <div className="pl-[30px] pr-[30px] xl:pr-[5px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[20px] 2xl:pt-[25px]">
                            {
                                isLoading ?
                                    <div className="items-center justify-center flex pt-[30px]">
                                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                                    </div>
                                    :
                                    <div className="md:mx-[30px] lg:mx-[100px] xl:mx-[60px]">
                                        <div>
                                            <input
                                                type="search"
                                                placeholder={t('t228')}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                value={searchInput}
                                                className="mt-4 p-2 md:p-3 lg:p-4 xl:p-1 2xl:p-2 border border-gray-300 rounded-md w-full text-black text-[15px] md:text-[18px]"
                                            />
                                        </div>
                                        <div className="flex justify-evenly md:justify-center xl:justify-start">
                                            <div className="w-[150px] h-[40px] md:w-[200px] md:h-[50px] xl:h-[40px] flex justify-center items-center text-[90px] md:text-[22px] xl:text-[16px] md:mr-[10px] min-w-[100px] rounded-md px-[2px] py-[0px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px]  border border-1 mt-[10px] border-gray-400 text-gray-700 bg-[#F1F6FB]">
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        value={date ? dayjs(date) : null}
                                                        onChange={(date) => {
                                                            if (date) {
                                                                const formattedDate = dayjs(date).format('YYYY-MM-DD');
                                                                setDate(formattedDate)
                                                            }
                                                        }}
                                                        format="YYYY-MM-DD"
                                                        slotProps={{
                                                            textField: {
                                                                InputProps: {

                                                                    style: {
                                                                        border: 'none',
                                                                        fontSize: window.innerWidth < 640 ? '14px' : window.innerWidth < 1024 ? '17px' : '17px',
                                                                        color: '#1F2937',
                                                                        fontFamily: 'Urbanist',
                                                                        padding: '0 0 0 0'
                                                                    },
                                                                },
                                                                placeholder: t('t229'),
                                                                fullWidth: true,
                                                                sx: {
                                                                    '& .MuiOutlinedInput-root': {
                                                                        border: 'none', // Remove outer border
                                                                        boxShadow: 'none', // Remove shadow
                                                                    },
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none', // Remove outlined border
                                                                    },
                                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none', // Remove hover effect
                                                                    },
                                                                    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none', // Remove focus effect
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                                {
                                                    !showCloseIcon && <MdCalendarMonth size="30px" className="xl:hidden text-gray-500 ml-[5px]" />
                                                }
                                                {
                                                    showCloseIcon && <MdClose onClick={() => setDate(null)} size="30px" className="2xl:block text-gray-500 ml-[5px]" />
                                                }
                                            </div>
                                            <button className={`text-[15px] md:text-[20px] xl:text-[16px] md:mr-[10px] rounded-md px-[15px] py-[5px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.inbox ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => {
                                                setNowReading(100000);
                                                localStorage.setItem("folder", 0);
                                                setFolderSelected({ sent: false, inbox: true, draft: false, rejected: false })
                                            }} >{t('t420')}</button>
                                            <button className={`text-[15px] md:text-[20px] xl:text-[16px] md:mr-[10px] rounded-md px-[15px] py-[5px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.rejected ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => {
                                                setNowReading(100000);
                                                localStorage.setItem("folder", 1);
                                                setFolderSelected({ sent: false, inbox: false, draft: false, rejected: true })
                                            }}>{t('t242')}</button>
                                        </div>

                                        <div className="hidden xl:block">
                                            {
                                                folderSelected.inbox &&
                                                <div className="mt-6">
                                                    {filteredEmailsInbox
                                                        .slice()
                                                        .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                                        .map((mail, index) => (
                                                            <div key={index} className={`cursor-pointer flex flex-col ${nowReading === index ? 'bg-[#D9D9D9]' : 'bg-[#F1F6FB]'} border border-[2px] mb-[10px] md:mb-[15px] p-[10px] rounded-md`}
                                                                onClick={() => {
                                                                    handleAllocateTranslator(mail, index);
                                                                }}
                                                            >
                                                                <div className="flex justify-between">
                                                                    <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.sender}</p>
                                                                    <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                                </div>
                                                                <div className="md:hidden text-black text-[13px] md:text-[17px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 30
                                                                            ? `${mail.subject.slice(0, 30)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden md:block lg:hidden text-black text-[13px] md:text-[17px] lg:text-[19px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 60
                                                                            ? `${mail.subject.slice(0, 60)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden lg:block xl:hidden text-black text-[13px] md:text-[17px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 70
                                                                            ? `${mail.subject.slice(0, 70)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 100
                                                                            ? `${mail.subject.slice(0, 100)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 140
                                                                            ? `${mail.subject.slice(0, 140)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                            </div>
                                                        ))}

                                                </div>
                                            }
                                            {
                                                folderSelected.rejected &&
                                                <div className="mt-6">
                                                    {filteredEmailRejected
                                                        .slice()
                                                        .sort((a, b) => new Date(b.sentAtOriginal).getTime() - new Date(a.sentAtOriginal).getTime())
                                                        .map((mail, index) => (
                                                            <div key={index} className={`cursor-pointer flex flex-col ${nowReading === index ? 'bg-[#D9D9D9]' : 'bg-[#F1F6FB]'} border border-[2px] mb-[10px] md:mb-[15px] p-[10px] rounded-md`}
                                                                onClick={() => {
                                                                    setNowReading(index)

                                                                    localStorage.setItem('mailreceived', JSON.stringify(mail));
                                                                    localStorage.removeItem('maildraft');
                                                                    localStorage.removeItem('mailsent');
                                                                    localStorage.setItem('composenewclicked', 'false');
                                                                    navigate('/desktop/translator/translatemail');
                                                                }}
                                                            >
                                                                <div className="flex justify-between">
                                                                    <p className="text-black text-[12px] md:text-[18px] lg:text-[20px] xl:text-[15px] 2xl:text-[17px] font-bold">{mail.sender}</p>
                                                                    <p className="text-black text-[12px] md:text-[17px] lg:text-[19px] xl:text-[15px] 2xl:text-[17px]">{mail.sentAt.slice(0, -3)}</p>
                                                                </div>
                                                                <div className="md:hidden text-black text-[13px] md:text-[17px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 30
                                                                            ? `${mail.subject.slice(0, 30)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden md:block lg:hidden text-black text-[13px] md:text-[17px] lg:text-[19px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 60
                                                                            ? `${mail.subject.slice(0, 60)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden lg:block xl:hidden text-black text-[13px] md:text-[17px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 70
                                                                            ? `${mail.subject.slice(0, 70)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden xl:block 2xl:hidden text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 100
                                                                            ? `${mail.subject.slice(0, 100)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                                <div className="hidden 2xl:block text-black text-[13px] md:text-[17px] xl:text-[15px]">
                                                                    <p>{mail.subject.trim() !== "" ?
                                                                        (mail.subject.length > 140
                                                                            ? `${mail.subject.slice(0, 140)}...`
                                                                            : mail.subject) : "(No subject)"}</p>
                                                                </div>
                                                            </div>
                                                        ))}

                                                </div>
                                            }

                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
                <div className=" ">
                    <>
                        <div className="xl:bg-[#FFEBA9] xl:rounded-md mb-[200px] xl:mb-[10px] pl-[30px] xl:pl-[20px] xl:ml-[0px] 2xl:pl-[30px] pr-[30px] xl:pr-[20px] 2xl:pr-[30px] xl:mr-[80px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[1px] 2xl:pt-[5px] xl:pb-[20px] 2xl:pb-[30px] 2xl:pt-[0px] xl:mt-[20px] 2xl:mt-[30px]">
                            <div className="flex items-center mt-[20px] lg:ml-[70px] xl:ml-[0px] justify-between">
                                <div className="flex items-center justify-between w-full  md:mr-[30px] lg:mr-[130px]">
                                    <div className="flex items-center">
                                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                                            navigate('/mobile/translator/translatemail/inbox')
                                        }} />
                                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                                            navigate('/mobile/translator/translatemail/inbox')
                                        }} />
                                        <p className="font-bold text-[20px] ml-[10px] md:text-[20px] lg:text-[25px] xl:text-[19px] 2xl:text-[25px]">{t('t234')}</p>
                                    </div>
                                </div>
                            </div>

                            {
                                isLoading || isLoading2 ?
                                    <div className="items-center justify-center flex pt-[30px]">
                                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                                    </div>
                                    :
                                    <>
                                        <div className="flex items-center justify-center">
                                            <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                                {isReceived &&
                                                    <p className={`text-gray-500 text-[15px]`}>{t('t235')}:</p>
                                                }

                                                {
                                                    isReceived && <input value={content.sender} readOnly type="text" name="receptionist" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"
                                                    />
                                                }

                                            </div>
                                        </div>

                                        <div className="flex items-center justify-center">
                                            <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                                <p className={`text-gray-500 text-[15px]`}>{t('t236')}:</p>
                                                <input readOnly value={(content.subject.trim()) ? content.subject.trim() : "(No subject)"} type="text" name="subject" className={`ml-[10px] w-full bg-[#F1F6FB] text-[15px] ${content.subject.trim() ? 'text-gray-900' : 'text-gray-500'} placeholder:text-[#8189B0] focus:outline focus:outline-0`} placeholder={t('t224')}
                                                />
                                            </div>
                                        </div>

                                        <div className="flex items-center justify-center">
                                            <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                                <p className={`text-gray-500 text-[15px] whitespace-nowrap`}>{t('t416')}:</p>
                                                <input readOnly value={(content.language) ? content.language : "(No lanuage)"} type="text" name="language" className={`ml-[5px] w-full bg-[#F1F6FB] text-[15px] ${content.language ? 'text-gray-900' : 'text-gray-500'} placeholder:text-[#8189B0] focus:outline focus:outline-0`} placeholder={t('t416')}
                                                />
                                            </div>
                                        </div>

                                        <div className="mt-[20px] md:pl-[100px] lg:pl-[200px] xl:pl-[10px] flex flex-col gap-[5px] mb-[10px]">
                                            {/* {
                                                content.attachments &&
                                                <>
                                                    {(content.attachments).map((file, index) => 
                                                    (
                                                        <div key={index} className="flex items-center justify-between">

                                                            <div className="flex items-center cursor-pointer" onClick={() => handleDownload(file.fileName, file.fileUrl)}>
                                                                <MdFilePresent />
                                                                <p className="text-black text-[15px] md:text-[17px]">{file.fileName}</p>
                                                            </div>
                                                            <div className="pr-[10px]">
                                                                {
                                                                    content.moderatedAttachments.filter(attachment => attachment.fileUrl === file.fileUrl).length === 0 ?
                                                                        <MdCheckBoxOutlineBlank className="cursor-pointer" onClick={() => { content.moderatedAttachments.push(file) }} />
                                                                        :
                                                                        <MdCheckBox className="cursor-pointer" onClick={() => { content.moderatedAttachments.}} />
                                                                }
                                                            </div>
                                                        </div>

                                                    ))}
                                                </>
                                            } */}
                                            {
                                                content.attachments &&
                                                <>
                                                    {content.attachments.map((file, index) => {
                                                        const isSelected = content.moderatedAttachments.some(
                                                            attachment => attachment.fileUrl === file.fileUrl
                                                        );

                                                        return (
                                                            <div key={index} className="flex items-center justify-between">
                                                                {/* File Download Section */}
                                                                <div className="flex items-center cursor-pointer" onClick={() => handleDownload(file.fileName, file.fileUrl)}>
                                                                    <MdFilePresent />
                                                                    <p className="text-black text-[15px] md:text-[17px]">{file.fileName}</p>
                                                                </div>

                                                                {/* Selection Toggle */}
                                                                <div className="pr-[10px]">
                                                                    {!isSelected ? (
                                                                        <MdCheckBoxOutlineBlank
                                                                            className="cursor-pointer"
                                                                            onClick={() =>
                                                                                setContent(prev => ({
                                                                                    ...prev,
                                                                                    moderatedAttachments: [...prev.moderatedAttachments, file]
                                                                                }))
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <MdCheckBox
                                                                            className="cursor-pointer"
                                                                            onClick={() =>
                                                                                setContent(prev => ({
                                                                                    ...prev,
                                                                                    moderatedAttachments: prev.moderatedAttachments.filter(
                                                                                        attachment => attachment.fileUrl !== file.fileUrl
                                                                                    )
                                                                                }))
                                                                            }
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </>
                                            }

                                        </div>

                                        <div className="md:flex md:justify-center md:items-center">
                                            <div className="justify-center items-center w-full md:w-[600px]">
                                                <ReactQuill
                                                    modules={{ toolbar: false }}
                                                    value={content.body}
                                                    readOnly
                                                    theme="snow"
                                                    placeholder={t('t225')}
                                                    className="rounded-lg min-h-[400px] xl:min-h-[300px] 2xl:min-h-[500px] w-full mt-[5px] bg-[#F1F6FB] border border-gray-400 focus-within:shadow-[0_0_0_2px_rgba(156,163,175,1)]" />
                                            </div>
                                        </div>

                                        {
                                            content?.moderationRecord?.reason &&
                                            <div className="items-center mt-[20px] flex ">
                                                <textarea className={` rounded-md w-full bg-[#F1F6FB] text-[15px] text-[#1F2937] shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px] focus:border-none focus:outline-none py-[5px] px-[20px]`}
                                                    rows={7} cols={40}
                                                    placeholder="Reason for rejection"
                                                    readOnly
                                                    value={`Rejected reason : ${content?.moderationRecord?.reason || ''}`}
                                                />
                                            </div>
                                        }


                                        {
                                            !translatedMessage && content.messageId &&
                                            <div className="flex justify-center items-center">
                                                <button onClick={() => {
                                                    handleTranslate()
                                                }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">Translate</button>

                                            </div>
                                        }

                                        {
                                            translatedMessage && content.messageId &&
                                            <div className="flex justify-center items-center">
                                                <button onClick={() => {
                                                    handleTranslate()
                                                }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">Translate again</button>

                                            </div>
                                        }

                                        {
                                            translatedMessage &&

                                            <>
                                                {content.translatedSubject === "startMes" &&
                                                    <div className="flex items-center justify-center">
                                                        <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                                            <p className={`text-gray-500 text-[15px]`}>{t('t236')}:</p>
                                                            <input value={translatedSubject.trim() ? translatedSubject.trim() : "(No subject)"} type="text" name="subject" className={`ml-[10px] w-full bg-[#F1F6FB] text-[15px] ${translatedSubject.trim() ? 'text-gray-900' : 'text-gray-500'} placeholder:text-[#8189B0] focus:outline focus:outline-0`} placeholder={t('t224')}
                                                            />
                                                        </div>
                                                    </div>}
                                                <div className="md:flex md:justify-center md:items-center pt-[20px]">
                                                    <div className="justify-center items-center w-full md:w-[600px]">
                                                        <ReactQuill
                                                            value={translatedMessage}
                                                            onChange={handleChange}
                                                            modules={modules}
                                                            theme="snow"
                                                            placeholder="Message"
                                                            className="rounded-lg min-h-[400px] xl:min-h-[300px] 2xl:min-h-[500px] w-full mt-[5px] bg-[#F1F6FB] border border-gray-400 focus-within:shadow-[0_0_0_2px_rgba(156,163,175,1)]" />
                                                    </div>
                                                </div>
                                            </>
                                        }


                                        {
                                            content.type === 'PENPAL' && content.status === "PENDING" && translatedMessage &&
                                            <div className="flex justify-center items-center gap-[20px]">
                                                <button onClick={() => {
                                                    setReject(true)
                                                }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">Reject</button>

                                                <button onClick={() => {
                                                    forwardMail();
                                                }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">Forward</button>

                                            </div>
                                        }

                                        {
                                            content.type === 'PENPAL' && content.status === "REJECTED" && translatedMessage &&
                                            <div className="flex justify-center items-center">
                                                <button onClick={() => {
                                                    forwardMail();
                                                }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">Approve and forward</button>

                                            </div>
                                        }

                                        {
                                            reject &&
                                            <div className="items-center mt-[20px] flex ">
                                                <textarea className={` rounded-md w-full bg-[#F1F6FB] text-[15px] ${rejectMessage === "" ? 'text-gray-400' : 'text-[#1F2937]'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px] focus:border-none focus:outline-none py-[5px] px-[20px]`}
                                                    rows={7} cols={40}
                                                    placeholder="Reason for rejection"
                                                    onChange={(e) => (
                                                        setRejectMessage(e.target.value)
                                                    )}
                                                />
                                            </div>
                                        }

                                        {(rejectError) &&
                                            <p className='text-[#ff0000] text-[12px] mt-[5px] mx-[20px]'>State reasons for rejection</p>
                                        }
                                        {
                                            reject &&
                                            <div className="flex justify-center gap-[20px] ml-[20px] mr-[20px] mx-[20px] mt-[20px] xl:mt-[20px] ">
                                                <button onClick={clickReport} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[400px] hover:bg-opacity-80 bg-[#F2290E] bg-opacity-20">Report</button>
                                            </div>
                                        }
                                    </>
                            }


                        </div >

                    </>
                </div>
            </div>
            <div className="xl:hidden grid grid-cols-5 fixed bottom-0 w-full border-t border-gray-300 bg-white">
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/home.svg" alt="home" /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/mail.svg" /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/person.svg" /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/message.svg" /></div>
                <div className="flex justify-center py-[20px] lg:py-[30px]"><img src="/images/bottom-icons/settings.svg" /></div>
            </div>

            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open5}
                onClose={handleClose5}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t277')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose5}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open6}
                onClose={handleClose6}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t278')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose6}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open7}
                onClose={handleClose7}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t279')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose7}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    )
}

export default TranslatorMailDashboardDesktop;